import { Transaction } from '../models/Transactions';
import { exchangeRateRepository } from '../repositories/ExchangeRateRepository';
import { getCurrencyCode } from './Utils';

export function getTransactionDisplayAmount(transaction: Transaction): number {
  const aggregatedAmount = transaction.additionalInfos?.aggregatedTapZapAmount;

  if (aggregatedAmount === undefined || aggregatedAmount === null) {
    return transaction.amount;
  }

  if (transaction.amount === 0) {
    return aggregatedAmount;
  }

  return Math.abs(aggregatedAmount) * Math.sign(transaction.amount);
}

export function getTransactionDisplayAmountFiat(
  transaction: Transaction,
): number | undefined {
  const aggregatedFiat = transaction.additionalInfos?.aggregatedTapZapAmountFiat;
  const sign = transaction.amount === 0 ? 1 : Math.sign(transaction.amount);

  if (aggregatedFiat !== undefined && aggregatedFiat !== null) {
    return Math.abs(aggregatedFiat) * sign;
  }

  const aggregatedAmount = transaction.additionalInfos?.aggregatedTapZapAmount;
  if (aggregatedAmount !== undefined && aggregatedAmount !== null) {
    const currencyCode = transaction.currencyCodeFiat ?? getCurrencyCode();
    const exchangeRate = exchangeRateRepository.getCachedExchangeRateForSat(currencyCode);

    if (exchangeRate !== null) {
      return getTransactionDisplayAmount(transaction) * exchangeRate;
    }
  }

  return transaction.amountFiat;
}

export function deduplicateByTapZapHash(transactions: Transaction[]): Transaction[] {
  const seen = new Set<string>();

  return [...transactions]
    .sort(
      (a, b) => new Date(b.time).getTime() - new Date(a.time).getTime(),
    )
    .filter((transaction) => {
      const hash = transaction.tapZapHash?.trim();

      if (!hash) {
        return true;
      }

      if (seen.has(hash)) {
        return false;
      }

      seen.add(hash);
      return true;
    });
}

export function prepareTransactionsForDisplay(
  transactions: Transaction[],
): Transaction[] {
  return deduplicateByTapZapHash(transactions);
}

export function filterSentTransactions(transactions: Transaction[]): Transaction[] {
  return prepareTransactionsForDisplay(transactions).filter(
    (transaction) => transaction.amount < 0,
  );
}

export function filterReceivedTransactions(transactions: Transaction[]): Transaction[] {
  return prepareTransactionsForDisplay(transactions).filter(
    (transaction) => transaction.amount >= 0,
  );
}

export function countUnreadTransactions(transactions: Transaction[]): number {
  return prepareTransactionsForDisplay(transactions).filter(
    (transaction) => transaction.read === false,
  ).length;
}
